export const FILE_QUERY_KEY = 'figma-file';
export const NODES_QUERY_KEY = 'figma-nodes';
export const IMAGE_QUERY_KEY = 'figma-image';
export const FILE_IMAGES_QUERY_KEY = 'figma-file-image';
